import { render, staticRenderFns } from "./DraggableGroupItems.vue?vue&type=template&id=e4f34512&"
import script from "./DraggableGroupItems.vue?vue&type=script&lang=js&"
export * from "./DraggableGroupItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports